import React from 'react';
import { Alert, Button, Modal } from 'antd';

const ServiceSheetMissingModal = ({ visible, onClose }) => (
  <Modal
    title="Something is missing"
    visible={visible}
    width={400}
    onCancel={onClose}
    footer={
      <Button type="primary" onClick={onClose}>
        Understood
      </Button>
    }
  >
    <p style={{ fontWeight: 700, marginBottom: 16 }}>
      You can not move this booking to the selected status until the garage has submitted the service sheet.
    </p>
    <Alert
      type="error"
      showIcon
      message="The Service Sheet is required, please ask the garage to fill it out."
    />
  </Modal>
);

ServiceSheetMissingModal.displayName = 'ServiceSheetMissingModal';

export default ServiceSheetMissingModal;
